export type UnitSystem = 'metric' | 'imperial';

export type UnitQuantity =
  | 'length'
  | 'area'
  | 'volume'
  | 'mass'
  | 'force'
  | 'moment'
  | 'stress'
  | 'density'
  | 'price';

export interface UnitDefinition {
  siUnit: string;
  impUnit: string;
  factor: number;
  precision: number;
}

export const UNIT_DEFINITIONS: Record<UnitQuantity, UnitDefinition> = {
  length:  { siUnit: 'mm',     impUnit: 'in',      factor: 1 / 25.4,       precision: 2 },
  area:    { siUnit: 'mm²',    impUnit: 'in²',     factor: 1 / 645.16,     precision: 2 },
  volume:  { siUnit: 'mm³',    impUnit: 'in³',     factor: 1 / 16387.064,  precision: 2 },
  mass:    { siUnit: 'kg',     impUnit: 'lb',      factor: 2.2046226,      precision: 2 },
  force:   { siUnit: 'N',      impUnit: 'lbf',     factor: 0.224809,       precision: 2 },
  moment:  { siUnit: 'N·mm',   impUnit: 'lbf·in',  factor: 0.00885075,    precision: 2 },
  stress:  { siUnit: 'MPa',    impUnit: 'ksi',     factor: 0.145038,       precision: 2 },
  density: { siUnit: 'kg/m³',  impUnit: 'lb/in³',  factor: 3.6127e-5,     precision: 4 },
  price:   { siUnit: '$/kg',   impUnit: '$/lb',    factor: 0.453592,       precision: 2 },
};
